import React from 'react'
import Navbar from '../../components/navbar/Navbar'

const Copyright = () => {
  return (
    <>
      <Navbar showLinks={true} />
      <div className="pages-container">
        <h1 className="pages-content">Copyright Policy Coming Soon!</h1>
      </div>
    </>
  )
}

export default Copyright